module.exports = __webpack_public_path__ + "media/tips.d8f21b4b.mp3";